import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

/**
 * Redirects user on first load only.
 */
export const useAuthRedirect = (redirectRoute: string): void => {
  const { isAuthenticated, isAuthChecked } = useAuthState()
  const isFirstLoad = useRef(true)
  const router = useRouter()
  useEffect(() => {
    if (!isFirstLoad.current || !isAuthChecked) return
    if (!isAuthenticated) isFirstLoad.current = false
    else router.push(redirectRoute)
  }, [isFirstLoad, isAuthenticated, isAuthChecked, router, redirectRoute])
}
